import { buildCardPaymentCore } from '@src/domains/payments/core/buildCardPaymentCore';
import { normalizeZipCode } from '@src/domains/payments/core/normalizeZipCode';
import type { PaymentCardParams } from '@src/domains/payments/types/payment';

export type DomCardInput = {
  cardNumber?: string;
  securityCode?: string;
  holder?: string;
  holderIdentity?: string;
  installments?: string;
  validity?: string;
  zipCode?: string;
  state?: string;
  city?: string;
  district?: string;
  street?: string;
  number?: string;
  complement?: string;
  countryCode?: string;
};

// TODO: Backend can't accept countryCode yet, remove AddressWithCountryCode and PaymentCardParamsWithCountryCode when backend is updated
type AddressWithCountryCode = PaymentCardParams['billingAddress'] & { countryCode?: string | null };
type PaymentCardParamsWithCountryCode = PaymentCardParams & { billingAddress: AddressWithCountryCode };

export const buildPaymentCardParamsFromDom = (input: DomCardInput): PaymentCardParams | undefined => {
  if (Object.keys(input).length === 0) {
    return undefined;
  }

  // The address fields below are nulled rather than omitted, and countryCode is sent: the legacy
  // checkout's contract. The direct link builder deliberately does neither — see the parity table.
  const params: PaymentCardParamsWithCountryCode = {
    ...buildCardPaymentCore(input),
    // Not normalizeHolderIdentity: the legacy form hides this field from foreign buyers instead of
    // nulling it here, and leaves an unfilled field as '' rather than null.
    holderIdentity: input.holderIdentity?.replace(/\W/g, '') ?? null,
    billingAddress: {
      zipCode: normalizeZipCode(input.zipCode),
      state: input.state ?? null,
      city: input.city ?? null,
      district: input.district ?? null,
      street: input.street ?? null,
      number: input.number ?? null,
      complement: input.complement ?? null,
      countryCode: input.countryCode ?? null,
    },
  };

  return params;
};
